import React from "react";

export default function PrivacyPolicy() {
  return (
    <main
      className="faq-wrapper"
      style={{ alignItems: "flex-start", paddingTop: "3rem" }}
    >
      <div className="faq-container">
        <h1 className="faq-title">Privacy Policy</h1>
        <p
          style={{
            color: "var(--text-secondary)",
            fontSize: "1.1rem",
            lineHeight: "1.6",
          }}
        >
          Placeholder for Privacy Policy content.
        </p>
      </div>
    </main>
  );
}
